// @flow
import React from "react";

import Spinner from "../../Spinner/Spinner";
import {
    AwaitingDriverCancel,
    AwaitingDriverCancelContainer, AwaitingDriverCancelLabel,
    AwaitingDriverContainer,
    AwaitingDriverTitle
} from "./AwaitingDriverStyle";
import {strings} from "../../../config";
import partnerLogo from "../../../Assets/commonImages/cancel_flex_proposal.svg";
import {connect} from "react-redux";
import {bindActionCreators} from "redux";
import CurrentRideOperations from "../../../Store/Ducks/CurrentRide/operations";

type ConnectedProps = {|
    onCancelRideOrProposalClick: () => mixed;
|}
type OwnProps = {||};
const AwaitingDriver = (props: OwnProps & ConnectedProps) => {
    return (
        <AwaitingDriverContainer>
            <AwaitingDriverTitle>
                {strings.waiting_driver_approval_title}
            </AwaitingDriverTitle>
            <Spinner/>
            <AwaitingDriverCancelContainer>
                <AwaitingDriverCancel onClick={props.onCancelRideOrProposalClick}>
                    <img src={partnerLogo} alt={"cancel_image"}/>
                    <br/>
                    <AwaitingDriverCancelLabel>
                        {strings.waiting_driver_approval_cancel_text}
                    </AwaitingDriverCancelLabel>
                </AwaitingDriverCancel>
            </AwaitingDriverCancelContainer>
        </AwaitingDriverContainer>
    );
};

const mapStateToProps = (state, props) => {
    return {};
};

const mapActionsToProps = (dispatch, props) => {
    return bindActionCreators(
        {onCancelRideOrProposalClick: CurrentRideOperations.cancelRideOrProposalClick},
        dispatch);
};

export default connect(mapStateToProps, mapActionsToProps)(AwaitingDriver);



// WEBPACK FOOTER //
// ./src/Components/GreyOverlay/AwaitingDriver/AwaitingDriver.js